import React from "react";
import './CardCorteSemanalBanco.css'

export default function CardCorteSemanalBanco(props){

    let dollarUSLocale = Intl.NumberFormat('en-US');

    return(
        <div className='d-flex flex-wrap justify-content-evenly globalCardsCorteSemanalBanco'>
            <div className='cardCorteSemanalBanco cardCorteSemanalBanco--no-border-left'>
                <small className='color-verde font-weight-bold'>Ingresos en banco:</small>
                <h2 className="text-md-right">$&nbsp;
                {props.total_ingresos_banco !== undefined
                    ? dollarUSLocale.format(props.total_ingresos_banco)
                    : 0}
                </h2>
            </div>
            <div className='cardCorteSemanalBanco'>
                <small className='color-rojo font-weight-bold'>Gastos en banco:</small>
                <h2 className="text-md-right">$&nbsp;
                {props.total_gastos_banco !== undefined
                    ? dollarUSLocale.format(props.total_gastos_banco)
                    : 0}
                </h2>
            </div>
            <div className='cardCorteSemanalBanco'>
                <small className='font-weight-bold'>Total en banco:</small>
                <h2 className="text-md-right">$&nbsp;
                {props.total_banco !== undefined
                    ? dollarUSLocale.format(props.total_banco)
                    : 0}
                </h2>
            </div>
        </div>

    )
}